module.exports = __webpack_public_path__ + "img/icon-gallery.3f0df6e1.svg";